<template>
  <transition name="fade">
    <v-dialog scrollable v-model="isVisible" max-width="700">
      <v-card class="bg-white rounded-xl overflow-auto position-relative pa-8">
        <slot />
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
export default {
  name: 'PopupModal',
  data: () => ({
    isVisible: false
  }),
  methods: {
    open() {
      this.isVisible = true
    },
    close() {
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
